<template>
  <div>
    <transition name="fade">
      <div :class="[ 'overlay' ]" v-if="open" v-on:click="close"></div>
    </transition>
    <transition name="slide">
      <div class="body loading" v-if="open && isLoading">
        <span class="spinner-border spinner-border" role="status"></span>
      </div>
      <div class="body" v-else-if="open">
        <div class="title">
          <button class="btn" v-on:click="close">
            <img src="../assets/icons/back.svg" alt="Back" />
          </button>
          Recently Updated This Month
        </div>
        <div class="updates">
          <router-link v-for="(update, i) in updates" :key="i" to="#" class="update">
            <div class="date">{{ getLongDate(update.date) }}</div>
            <div class="title">{{ update.title }}</div>
            <div class="text">{{ update.text }}</div>
            <div class="user">
              <div class="avatar">
                <Avatar :name="update.user.name" />
              </div>
              <div class="name">{{ update.user.name }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Avatar from "./Avatar.vue";

export default {
  name: 'RecentUpdates',
  components: {
    Avatar,
  },
  props: [ 'open', 'close' ],
  data: function () {
    return {
      isLoading: true,
      updates: [],
    };
  },
  watch: {
    open: function(newVal) {
      if (newVal === true) {
        this.updates = [];
        this.isLoading = true;
        axios.get('/api/dashboard/metrics/recent-updates/read')
          .then((response) => {
            this.isLoading = false;
            if (response.data.updates) {
              this.updates = response.data.updates;
            }
          });
      }
    }
  },
  methods: {
    getLongDate: function (dateStr) {
      let date = new Date(dateStr);
      return date.toLocaleString('en-US', { weekdat: 'long', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', dayPeriod: 'short' });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.overlay {
  background: rgba(black, 0.5);
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

div.body {
  position: fixed;
  z-index: 11;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  background: white;
  width: 550px;
  overflow-y: auto;
  padding: 60px 27px 2rem;

  &.loading {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > div.title {
    color: #4A4A4A;
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.2;
    position: relative;
    padding-left: 1rem;
    margin: 0 0 57px;

    button {
      position: absolute;
      right: calc(100% - 1rem);
      padding: 0 10px;
    }
  }
}

a.update {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border: 1px solid #ECECEC;
  box-shadow: 0 10px 30px 0 rgba(0,0,0,0.07);
  border-radius: 4px;
  padding: 25px;
  transition: transform 250ms;
  margin: 0 0 1rem;

  &:hover {
    text-decoration: none;
    transform: translateX(10px);

    div.title,
    div.text {
      color: var(--accentColor);
    }
  }

  div.date {
    font-size: 0.75rem;
    line-height: 2;
    color: rgba(#222222, 0.56);
    margin: 0 0 21px;
  }

  div.title {
    font-weight: 500;
    font-size: 0.875rem;
    line-height: calc(17 / 14);
    margin: 0 0 8px;
    color: #4A4A4A;
    transition: color 250ms;
  }

  div.text {
    font-size: 1.25rem;
    line-height: calc(23 / 20);
    color: #4A4A4A;
    transition: color 250ms;
  }

  div.user {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    margin-top: 28px;
    padding: 25px 0 0;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: -25px;
      right: -25px;
      height: 1px;
      background-color: #EBEBEB;
    }

    div.name {
      padding-left: 20px;
      font-size: 1rem;
      line-height: calc(18 / 16);
      color: #4A4A4A;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-enter-active, .slide-leave-active {
  transition: transform .25s;
}
.slide-enter, .slide-leave-to {
  transform: translateX(550px);
}
</style>
